<div class="o-layout__item c-section__right u-layout-grow">
  <div class="c-form__item u-layout-auto u-width-3">
    <div class="c-form__keyboard">
      <input
        *ngFor="let input of gridValues; index as index; trackBy: trackByMethod"
        type="text"
        (change)="textValueChanged($event, index)"
        (keyup)="textValueChanged($event, index)"
        [value]="gridValues[index]"
        [maxLength]="maxLength"
      />
    </div>
  </div>
</div>
